export default class GlobalRegistry {
  constructor(gsConfig) {
    this.gsConfig = gsConfig || {};
  }

  getStoreId() {
    return this.gsConfig.shstoreId;
  }

  getCurrentLocale() {
    return this.gsConfig.currentLocale;
  }

  getDefaultLocale() {
    return this.gsConfig.defaultLocale;
  }

  getDefaultWebTLD() {
    return this.gsConfig.defaultWebTLD;
  }

  getSupporttedLocales() {
    return this.gsConfig.supportedLocales || [];
  }

  getSupportedCountries() {
    return this.gsConfig.supportedCountries || [];
  }

  getCurrentCountry() {
    const currentLocale = this.getCurrentLocale();

    return currentLocale && currentLocale.split('-')[1].toUpperCase();
  }

  getFeatureValue(name) {
    const features = this.gsConfig.features || {};

    return features[name];
  }
  getPropertyValue(name) {
    const props = this.gsConfig.properties || {};

    return props[name];
  }

  getRedirectionRules() {
    return this.gsConfig.redirectionRules || {};
  }
}
